import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { IStoreState } from "../../../../reducers/types";
import {
  getHasLocationAutocompleteError,
  getLocation,
  getLocationCategories,
  getLocationCategoriesLoading,
} from "../../reducer";
import {
  getTripDestinations,
  getTripDestinationsLoading,
} from "../../reducer";
import { MobileExperiencesSearchControl } from "./component";
import {
  setLocation,
  fetchLocationCategories,
  setLocationAutocompleteError,
} from "../../actions/actions";

const mapDispatchToProps = {
  setLocation,
  fetchLocationCategories,
  setLocationAutocompleteError,
};
const mapStateToProps = (state: IStoreState) => ({
  searchLocation: getLocation(state),
  locationCategories: getLocationCategories(state),
  loading: !!getLocationCategoriesLoading(state),
  hasLocationAutocompleteError: getHasLocationAutocompleteError(state),
  tripDestinations: getTripDestinations(state),
  tripDestinationsLoading: getTripDestinationsLoading(state),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileExperiencesSearchConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileExperiencesSearchControl = withRouter(
  connector(MobileExperiencesSearchControl)
);
